var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _vm.label ? _c("label", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
    _vm._v(" "),
    _c("img", {
      staticClass: "img-thumbnail form-control-plaintext",
      attrs: { src: _vm.path, alt: _vm.alt },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }